import { browser } from '$app/environment';
import { init, register } from 'svelte-i18n';
export { getLocalizedText } from './text';

const localeLoaders = {
    no: () => import('./no.json').then((module) => module.default),
    en: () => import('./en.json').then((module) => module.default),
    sv: () => import('./sv.json').then((module) => module.default),
    da: () => import('./da.json').then((module) => module.default)
} as const;

for (const [supportedLocale, loader] of Object.entries(localeLoaders)) {
    register(supportedLocale, loader);
}

// Get initial locale from localStorage or default to 'no'
const initialLocale = browser ? localStorage.getItem('language') || 'no' : 'no';

init({
    fallbackLocale: 'no',
    initialLocale,
    formats: {
        number: {
            NOK: { style: 'currency', currency: 'NOK' }
        },
        date: {
            short: { month: 'numeric', day: 'numeric', year: 'numeric' }
        },
        time: {
            short: { hour: 'numeric', minute: 'numeric' }
        }
    },
    // Handle missing messages with a default value if provided
    handleMissingMessage: ({ locale, id, defaultValue }) => {
        console.warn(`Missing translation: ${id} for locale: ${locale}`);
        return defaultValue || id;
    }
});
